import { useState } from 'react';
import Schedule from './Schedule';
import Analytics from './Analytics';
import { useTimeblock } from '../../hooks/useTimeblock';

const SUB_TABS = [
    { id: 'schedule', label: 'Schedule' },
    { id: 'analytics', label: 'Analytics' }
];

function TimeBlock() {
    const [activeSubTab, setActiveSubTab] = useState('schedule');
    const hook = useTimeblock();

    return (
        <div className="space-y-4">
            {/* Sub-tab switcher */}
            <div className="flex gap-1 bg-[var(--surface-bg-lighter)] p-1 rounded-lg w-fit">
                {SUB_TABS.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveSubTab(tab.id)}
                        className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${
                            activeSubTab === tab.id
                                ? 'bg-[var(--surface-bg)] text-[var(--text-primary)] shadow-sm'
                                : 'text-[var(--text-muted)] hover:text-[var(--text-secondary)]'
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Content */}
            {activeSubTab === 'schedule' ? (
                <Schedule hook={hook} />
            ) : (
                <Analytics hook={hook} />
            )}
        </div>
    );
}

export default TimeBlock;
